import { render } from "./DropdownTrigger.vue?vue&type=template&id=c85207e2"
import script from "./DropdownTrigger.vue?vue&type=script&lang=js"
export * from "./DropdownTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DropdownTrigger.vue"]])

export default __exports__